export enum Industry {
  Carport = 'carport',
  Shed = 'shed',
}
